import React from 'react';
import { Platform, TouchableOpacity, Text, StyleSheet } from 'react-native';

const ArrowButton = ({ direction = 'left', onPress, style, className, ariaLabel }) => {
  const label = ariaLabel || (direction === 'left' ? 'Anterior' : 'Siguiente');
  const symbol = direction === 'left' ? '❮' : '❯';

  // Web button variant (used by BannerBancarioWeb via className for CSS styling)
  if (Platform.OS === 'web' && className) {
    return (
      <button type="button" className={className} onClick={onPress} aria-label={label}>
        <span style={{ color: '#fff', fontSize: 18, lineHeight: 1 }}>{symbol}</span>
      </button>
    );
  }

  // React Native variant (used by BannerPrincipal y BannerInferior)
  return (
    <TouchableOpacity
      onPress={onPress}
      style={[styles.arrowButton, direction === 'left' ? styles.leftArrow : styles.rightArrow, style]}
      accessibilityLabel={label}
    >
      <Text style={styles.arrowText}>{symbol}</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  arrowButton: {
    position: 'absolute',
    top: '50%',
    transform: [{ translateY: -20 }],
    width: 40,
    height: 40,
    backgroundColor: 'rgba(252, 1, 1, 0.5)',
    borderRadius: 25,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
  },
  leftArrow: {
    left: 10,
  },
  rightArrow: {
    right: 10,
  },
  arrowText: {
    color: '#fff',
    fontSize: 24,
    fontWeight: 'bold',
  },
});

export default ArrowButton;
